import React from 'react';

/**
 * Rotas com layout próprio (sem Header/Footer do site e sem o layout admin).
 * Usadas pelo wizard de agendamento, pensado para mobile e acessado por link direto.
 */
const wizardRoutes = [
  {
    key: 'agendar',
    path: `/agendar`,
    component: React.lazy(() => import('views/website/Agendar')),
    authority: [],
  },
];

export default wizardRoutes;
